import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import Flag04 from 'src/app/icons/Monospaced/Flag/Flag04';
import MessageChatCircle from 'app/icons/Monospaced/MessageChat/MessageChatCircle';
import Star01 from 'src/app/icons/Monospaced/Star/Star01';
import Users01 from 'src/app/icons/Monospaced/Users/Users01';
import { cssVar } from 'src/app/styles/helper';
import { FeaturesClickable, ProMegaMenuStack } from './MightyProMegaMenu.styles';

const proFeatures = [
  {
    title: 'Pro Features',
    description: 'Your own branded apps are just the beginning.',
    href: '/pro',
    icon: (
      <Flag04
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    title: 'Pro Services',
    description: (
      <span>
        We’ll set you up with the software <em>and</em> our proven $1M+ playbook.
      </span>
    ),
    href: '/pro/services',
    icon: (
      <Users01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    title: 'Pro Spotlight',
    description: 'The names you know are making major moves on Mighty.',
    href: '/case-studies?mightyPlans=Mighty%20Pro',
    icon: (
      <Star01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    title: 'Talk to Sales',
    description: `They'll lay out a personalized business case—your ROI roadmap.`,
    href: '/request-a-call-form',
    icon: (
      <MessageChatCircle
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
];

const MightyProMegaMenuFeatures = (): JSX.Element => {
  return (
    <Stack
      align='stretch'
      direction='row'
      maxWidth='width-3xl'
      justify='space-between'
      margin={['spacing-none', 'spacing-auto']}
      padding={['spacing-3xl', 'spacing-4xl']}
      paddingLg='spacing-xl'
    >
      <Grid
        totalColumns={4}
        totalColumnsLg={1}
        gap='spacing-xs'
      >
        {proFeatures.map((feature) => (
          <FeaturesClickable
            key={feature.title}
            href={feature.href}
          >
            <ProMegaMenuStack
              direction='row'
              gap='spacing-lg'
              align='flex-start'
              padding='spacing-lg'
              paddingLg={['spacing-lg', 'spacing-none', 'spacing-lg', 'spacing-none']}
              background='bg-primary'
              borderRadius={'radius-md'}
            >
              {feature.icon}
              <Stack
                direction='column'
                className='feature-content'
              >
                <Typography
                  type='paragraph'
                  size='md'
                  fontWeight='font-weight-semibold'
                  color='text-primary'
                >
                  {feature.title}
                </Typography>
                <Typography
                  type='paragraph'
                  size='sm'
                  color='text-tertiary'
                >
                  {feature.description}
                </Typography>
              </Stack>
            </ProMegaMenuStack>
          </FeaturesClickable>
        ))}
      </Grid>
    </Stack>
  );
};

export default MightyProMegaMenuFeatures;
